import React from "react";
import { useTranslation } from "react-i18next";
import { Megaphone, Search, Bot, MessageSquare, Send, PhoneCall, MessageCircle, Users, Globe, UserPlus, HelpCircle } from "lucide-react";
import { capitalizeName } from "../../utils/displayName";
import { bookedVia } from "./bookedVia";

// De dónde salió el lead. `origin` lo calcula el backend (aws_lambdas/_shared_demo/leadOrigin.js
// y, si la demo lo trae grabado, v_demos.lead_source — ver leadSource.js) para demos
// (v_manageDemos) y pendientes (v_leadRequests): aquí solo se pinta. Con `demo` se añade, como
// detalle, el canal por el que agendó («Anuncio Meta · agendó por WhatsApp»; ver bookedVia.js).
const STYLE = {
  meta_ads: { Icon: Megaphone, cls: "bg-blue-50 text-blue-700 border-blue-200" },
  google_ads: { Icon: Search, cls: "bg-amber-50 text-amber-700 border-amber-200" },
  chatgpt_ads: { Icon: Bot, cls: "bg-teal-50 text-teal-700 border-teal-200" },
  whatsapp_captacion: { Icon: MessageSquare, cls: "bg-green-50 text-green-700 border-green-200" },
  flow_vendedor: { Icon: Send, cls: "bg-purple-50 text-purple-700 border-purple-200" },
  cold_call: { Icon: PhoneCall, cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  whatsapp_inbound: { Icon: MessageCircle, cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  referral: { Icon: Users, cls: "bg-pink-50 text-pink-700 border-pink-200" },
  landing: { Icon: Globe, cls: "bg-gray-100 text-gray-600 border-gray-200" },
  manual: { Icon: UserPlus, cls: "bg-slate-100 text-slate-600 border-slate-200" },
  unknown: { Icon: HelpCircle, cls: "bg-gray-50 text-gray-400 border-gray-200" },
};

export default function OriginChip({ origin, demo = null, size = "xs" }) {
  const { t } = useTranslation("misAgendas");
  if (!origin || !origin.kind) return null;
  const { Icon, cls } = STYLE[origin.kind] || STYLE.unknown;
  const by = origin.by ? capitalizeName(origin.by) : "";
  const label = by && ["flow_vendedor", "cold_call", "manual"].includes(origin.kind)
    ? t(`leadOrigin.${origin.kind}_by`, { by })
    : t(`leadOrigin.${origin.kind}`);
  const via = bookedVia(demo, origin.kind);
  const viaLabel = via ? t(`leadOrigin.via.${via}`) : "";
  const base = (origin.kind === "meta_ads" || origin.kind === "chatgpt_ads" || origin.kind === "google_ads") && (origin.campaign || origin.content)
    ? t("leadOrigin.metaHint", { campaign: origin.campaign || "—", content: origin.content || "—" })
    : label;
  const title = viaLabel ? `${base} · ${viaLabel}` : base;
  const sz = size === "sm" ? "text-xs px-2 py-0.5" : "text-[11px] px-1.5 py-0.5";
  return (
    <span title={title} className={`inline-flex items-center gap-1 rounded-full border font-semibold whitespace-nowrap ${sz} ${cls}`}>
      <Icon size={11} /> {label}
      {viaLabel && <span className="font-normal opacity-75">· {viaLabel}</span>}
    </span>
  );
}
